import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Badge from '@repo/ui/badge'
import { EyeOpenIcon } from '@repo/ui/icons'
import Modal, { MODAL_CONTENT_CLASSNAME } from '@repo/ui/modal'
import { useRef } from 'react'

import { API } from '../../../api/apis.config'
import { useObserver } from '../../../lib/contexts/observer'
import useEnrollment from '../../../lib/hooks/use-enrollment'
import { useModalManager } from '../../../lib/hooks/use-modal-manager'
import useTranslate from '../../../lib/hooks/use-translate'
import {
  CenterEvent,
  CenterEventFilter
} from '../../../lib/types/models/center-event/center-event'
import CenterEventData from '../../../views/centers/center-details/center-event/center-event-data'
import DynamicDataTable, { DynamicTableRef } from '../../elements/dynamic-table'
import { getCenterEventColumns } from '../center-events/utils'

type Props = {
  filter?: CenterEventFilter
}

const EnrollmentProfileEvents = ({ filter }: Props) => {
  const tableRef = useRef<DynamicTableRef<CenterEvent>>(null)
  const { enrollment } = useEnrollment()
  const { t } = useTranslate()

  const { toggleModal, modalState, selectedData } = useModalManager<'view', CenterEvent>(['view'])

  useObserver({
    key: 'enrollment-events',
    update: () => tableRef.current?.refetch()
  })

  if (!enrollment.enrollmentCenter?.center.id) return null

  return (
    <>
      <DynamicDataTable<CenterEvent, CenterEventFilter>
        ref={tableRef}
        columns={[
          ...getCenterEventColumns('VIEW', t),
          {
            accessorKey: 'status',
            header: '',
            columnHeaderClassName: 'w-20',
            cell: ({ row }) => (
              <Badge
                variant="primary"
                size="xsmall"
                className="py-4 rounded"
                onClick={() => toggleModal('view', row.original)}
                icon={<EyeOpenIcon color={tailwindColors.primary.DEFAULT} />}
              />
            )
          }
        ]}
        paginated={false}
        headerType="none"
        filters={{ centerIds: [enrollment.enrollmentCenter.center.id], ...filter }}
        endpoint={API.centerEvents.getAll.url}
      />

      {selectedData && (
        <Modal
          isOpen={modalState.view}
          hideActions
          size="large"
          // icon={}
          onCancel={() => toggleModal('view')}
        >
          <CenterEventData
            centerEvent={selectedData}
            className={MODAL_CONTENT_CLASSNAME}
            mode="VIEW"
          />
        </Modal>
      )}
    </>
  )
}

export default EnrollmentProfileEvents
